import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import crossIcon from "assets/images/cross.svg";
import staffModalStyles from "pages/Staff/staff.module.scss";
import credStyles from "./Credentials.module.scss";

/**
 * Help modal for Credentials & Licensing notification preferences.
 * Pattern mirrors PolicyHelpGuide (Office Policy Management).
 */
const CredentialsLicensingHelpGuide = ({ isOpen, onClose, t }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => onClose(false)}
      className="modal-md modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span
        className="close-btn"
        onClick={() => onClose(false)}
        onKeyDown={(e) =>
          (e.key === "Enter" || e.key === " ") && onClose(false)
        }
        role="button"
        tabIndex={0}
      >
        <img src={crossIcon} alt="" />
      </span>
      <ModalBody>
        <p className="title">{t("helpGuide")}</p>
        <div className={staffModalStyles.modal_container}>
          <div className={credStyles.helpGuideSection}>
            <h5 className={staffModalStyles.title_style}>
              {t("accountOwner.manageStaffCredentialExpiryReminders")}
            </h5>
            <p>{t("accountOwner.credentialsLicensingHelpStaffBody")}</p>
          </div>
          <div className={credStyles.helpGuideSection}>
            <h5 className={staffModalStyles.title_style}>
              {t("accountOwner.manageOfficeCredentialExpiryReminders")}
            </h5>
            <p>{t("accountOwner.credentialsLicensingHelpOfficeBody")}</p>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default withTranslation()(CredentialsLicensingHelpGuide);
